import {
  Button,
  Card,
  CardContent,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
} from "@mui/material";
import { Box, Divider, IconButton, Typography } from "@mui/material";
import { ErrorMessage, Field, Form, Formik } from "formik";
import React, { useEffect, useState } from "react";
import ArrowBackIosNewOutlinedIcon from "@mui/icons-material/ArrowBackIosNewOutlined";
import { userTypeData } from "../../Data/data";
import "./index.css";
import UserForm from "./UserForm/UserForm";
import VendorForm from "./VendorForm/VendorForm";
import { useNavigate } from "react-router-dom";
import {
  createUserValidations,
  userValidations,
} from "../../Validations/Validations";
import functions from "../../utils/Api";
import Toaster from "../../components/Toaster/Toaster";
import { useDispatch, useSelector } from "react-redux";
import { Switch } from "@mui/material";
import { setUserPermissions } from "../../Redux/reportSlice";
import { setUserType } from "../../Redux/persistApiDataSlice";

const Admin = ({
  title,
  userDetails,
  setUserDetails,
  toasterStatusMsg,
  handleSubmitUser,
  handleRedirect,
  // userFormValidations,
  disableBtn,
  loginDetails,
}) => {
  let navigate = useNavigate();
  const dispatcher = useDispatch();
  let userFormValidations = createUserValidations(title, userDetails.roleId);
  // let permissionList = useSelector(
  //   (state) => state.mealAppReducer.permissionsList
  // );
  const permissionList = useSelector(
    (state) => state.persistApiData.permissionList
  );
  let selector = useSelector((state) => state.report);
  const [permissioTypeId, setPermissionTypeId] = useState(permissionList);

  const handleRedirectUser = () => {
    handleRedirect();
    // navigate("/cms/users-list");
  };

  const handleUserDetails = (event, setFieldValue) => {
    const { name, value } = event.target;
    setUserDetails({
      ...userDetails,
      [name]: value,
    });
    setFieldValue(name, value); // Sync Formik value
  };

  const handleSubmit = (values) => {
    // console.log("userDetails", userDetails);
    let employeeDetails = userDetails;
    employeeDetails["email"] = userDetails.email.toLowerCase();
    employeeDetails["permission"] =
      userDetails.permission.length > 0 &&
      userDetails.permission.map((item) => {
        let details = {
          permissionId: item.permissionId,
          permissionName: item.permissionName,
          permissiondisplayName: item.permissiondisplayName,
        };
        return details;
      });
    // if (loginDetails?.email === userDetails?.email) {
    //   dispatcher(setUserPermissions(userDetails.permission));
    // }
    handleSubmitUser(employeeDetails);
  };

  const handleCancel = () => {
    dispatcher(setUserType(null));
    navigate("/cms/users-list");
  };

  const handleActive = (event) => {
    setUserDetails({
      ...userDetails,
      isActive: event.target.checked ? true : false,
    });
  };

  const renderUserType = () => {
    switch (userDetails.roleId) {
      case 1:
        return "Permanent Employee";
      case 2:
        return "Vendor";
      case 3:
        return "Contract Employee";
      default:
        break;
    }
  };

  return (
    <div>
      <Formik
        initialValues={userDetails}
        enableReinitialize={true}
        validateOnChange={true}
        validateOnBlur={true}
        validationSchema={userFormValidations}
        onSubmit={handleSubmit}
      >
        {({ touched, errors, setFieldValue, values, setFieldTouched }) => (
          <Form>
            <Box className="admin">
              <Card className="admin-body">
                <CardContent>
                  <Box className="Admin-titleMain">
                    <Box sx={{ display: "flex", alignItems: "center" }}>
                      <IconButton
                        aria-label="delete"
                        size="medium"
                        className="Admin-titleMain-iconBtn"
                        onClick={handleRedirectUser}
                        sx={{
                          "&:hover": {
                            background: "#004D72",
                            color: "#FFFFFF",
                          },
                        }}
                      >
                        <ArrowBackIosNewOutlinedIcon
                          fontSize="inherit"
                          sx={{ width: "15px" }}
                        />
                      </IconButton>
                      <Typography
                        variant="h6"
                        className="Admin-titleMain-label"
                      >
                        <b>
                          {title} {renderUserType()}
                        </b>
                      </Typography>
                    </Box>
                    {title === "Update" && (
                      <Box sx={{ display: "flex", alignItems: "center" }}>
                        <Typography
                          sx={{
                            color: "#464B4F",
                            fontWeight: "400",
                            marginRight: "10px",
                          }}
                        >
                          Status :
                        </Typography>
                        <Typography
                          sx={{ color: "#000000", fontWeight: "600" }}
                        >
                          Active
                        </Typography>
                        <Typography>
                          <Switch
                            color="success"
                            value={userDetails.isActive}
                            checked={userDetails.isActive ? true : false}
                            onChange={handleActive}
                          />
                        </Typography>
                        <Typography
                          sx={{ color: "#000000", fontWeight: "600" }}
                        >
                          InActive
                        </Typography>
                      </Box>
                    )}
                  </Box>
                  <Divider />
                  <Box>
                    <Grid container spacing={4} className="admin-formHeader">
                      <Grid item lg={8} md={6} sm={12} xs={12}>
                        <UserForm
                          userDetails={userDetails}
                          handleUserDetails={handleUserDetails}
                          touched={touched}
                          errors={errors}
                          values={values}
                          // permissionType={permissionType}
                          setFieldValue={setFieldValue}
                          setFieldTouched={setFieldTouched}
                          permissionList={permissionList}
                          setUserDetails={setUserDetails}
                          title={title}
                        />
                      </Grid>
                    </Grid>
                  </Box>
                </CardContent>
              </Card>
            </Box>
            <Box className="Admin-BtnMain">
              <Button
                variant="outlined"
                className="Admin-CancleBtn"
                onClick={handleCancel}
                sx={{ padding: "7px 24px" }}
              >
                Cancel
              </Button>
              <Button
                variant="contained"
                className="Admin-createBtn"
                type="submit"
                // disabled={disableBtn}
                sx={{ padding: "7px 24px" }}
              >
                {title}
              </Button>
            </Box>
          </Form>
        )}
      </Formik>
    </div>
  );
};

export default Admin;
